export const pubSubServiceDefinition = {
    id: `pub-sub`,
    create: () => {
        const listenersByTopic = new Map();
        return {
            '1.0.0': () => ({
                featureService: {
                    publish: (topic) => {
                        const listeners = listenersByTopic.get(topic);
                        if (listeners) {
                            for (const listener of listeners) {
                                listener();
                            }
                        }
                    },
                    subscribe: (topic, listener, options = {}) => {
                        var _a, _b;
                        const listeners = (_a = listenersByTopic.get(topic)) !== null && _a !== void 0 ? _a : new Set();
                        listenersByTopic.set(topic, listeners);
                        listeners.add(listener);
                        const unsubscribe = () => listeners.delete(listener);
                        (_b = options.signal) === null || _b === void 0 ? void 0 : _b.addEventListener(`abort`, unsubscribe);
                        return unsubscribe;
                    },
                },
            }),
        };
    },
};
//# sourceMappingURL=index.js.map